module.exports = __webpack_public_path__ + "img/newInt-activateicon.752d7ed2.svg";